// extracted by mini-css-extract-plugin
export default {"container":"AdminPage_container__2Xgi4"};